import styled from "@emotion/styled";

import { Button } from "scmp-app/components/common/button";

export const StyledIcon = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;

  color: var(--pswp-icon-color);
`;

export const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 44px;
  block-size: 44px;

  :hover {
    ${StyledIcon} {
      opacity: 0.8;
    }
  }
`;
